export enum ActivationMethod {
  NOT_ALLOWED = "NOT_ALLOWED",
  SIDELOAD = "SIDELOAD",
  KNOX_GUARD = "KNOX_GUARD",
  DLC = "DLC",
  QR_CODE = "QR_CODE",
}

export enum NotFixedState {
  DAMAGED_WORKING_PHONE = "DAMAGED_WORKING_PHONE",
  DAMAGED_NON_WORKING_PHONE = "DAMAGED_NON_WORKING_PHONE",
}

export enum ReturnedStatus {
  REPAIRED = "REPAIRED",
  REPLACED = "REPLACED",
  NO_WARRANTY = "NO_WARRANTY",
}

export enum RepairStatus {
  ACTIVATE = "activate",
  APP_REINSTALL_IN_PROCESS = "AppReinstallInProcess",
  APP_REINSTALL_SECURED = "AppReinstalledAndSecured",
  APP_REMOVED = "AppRemoved",
  BACK_FROM_WARRANTOR = "BackFromWarrantyProvider",
  CLOSE = "Closed",
  DEVICE_SWAP = "DeviceSwap",
  DEVICE_SWAP_ACTIVATION_IN_PROCESS = "DeviceSwapActivationInProcess",
  FACTORY_RESET_COMPLETED = "FactoryResetCompleted",
  FACTORY_RESET_IN_PROCESS = "FactoryResetInProcess",
  FULLY_UNLOCKED = "DeviceFullyUnlocked",
  NEW = "New",
  NO_WARRANTY = "NotCoveredByWarranty",
  PHONE_RETURNDED_NO_PJ_APP = "PhoneReturnedWithoutPJApp",
  RETURN_DEVICE = "PhoneReturnedToClient",
  SELECT_REPAIR_TYPE = "selectRepairType",
  SELECT_REPLACEMENT_DEVICE = "selectReplacementDevice",
  SEND_WARRANTOR = "SendToWarrantyProvider",
  SET_TO_REMOVABLE = "AppSetRemovable",
}

export enum RepairType {
  WARRANTY = "Warranty",
  FACTORY_RESET = "FactoryReset",
}

export interface IHandleWriteLog {
  status: RepairStatus;
  forceNextStatus?: RepairStatus;
  deviceRepairType?: RepairType;
  additionalContactName?: string;
  additionalContactPhone?: string;
  additionalContactEmail?: string;
  phoneProblemDescription?: string;
  referenceType?: string;
  referenceValue?: string;
}
